export default class TechnologyTrainController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/technologyTrain/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/technologyTrain/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/technologyTrain/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/technologyTrain/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/technologyTrain/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/technologyTrain/delete', 'post', params, axiosOption, httpOption);
  }

  static startOnlyTechnologyTrainFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/technologyTrain/startOnly/technologyTrainFlow', 'post', params, axiosOption, httpOption);
  }

  static startWithBusinessKeyTechnologyTrainFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/technologyTrain/startWithBusinessKey/technologyTrainFlow', 'post', params, axiosOption, httpOption);
  }

  static startAndTakeUserTaskTechnologyTrainFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/technologyTrain/startAndTakeUserTask/technologyTrainFlow', 'post', params, axiosOption, httpOption);
  }

  static startAndSaveDraftTechnologyTrainFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/technologyTrain/startAndSaveDraft/technologyTrainFlow', 'post', params, axiosOption, httpOption);
  }

  static submitUserTaskTechnologyTrainFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/technologyTrain/submitUserTask/technologyTrainFlow', 'post', params, axiosOption, httpOption);
  }

  static viewTaskBusinessDataTechnologyTrainFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/technologyTrain/viewTaskBusinessData/technologyTrainFlow', 'get', params, axiosOption, httpOption);
  }

  static viewHistoricTaskBusinessDataTechnologyTrainFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/technologyTrain/viewHistoricTaskBusinessData/technologyTrainFlow', 'get', params, axiosOption, httpOption);
  }

  static listWorkOrderTechnologyTrainFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/technologyTrain/listWorkOrder/technologyTrainFlow', 'post', params, axiosOption, httpOption);
  }
}
